<template>
    <div class="bee_float_layout" id="bee_reward_base_layout">

        <div class="icon_app_close_img" @click="doClose()" />
        <div class="reward_content">
            <div class="reward_xp_layout">
                <div style="color: #fff;">+<span style="color: #fff;">{{ xpValue }}</span></div>
                <div class="bee_experience_logo"></div>
            </div>



        </div>


    </div>
</template>

<script>

import Toast from "./message.js";
import { AccountStore } from "../util/Account.js";

export default {
    name: 'FloatView',

    components: {},

    props: {
        title: String,
        msg: String,
    },
    data() {
        return {
            xpValue: 0,
            userPage: 1,
            tgJs: "",
            loginUrl: "",
        }
    },

    watch: {
    },

    methods: {

        doClose() {
            let view = document.getElementById("bee_nReward");
            view.style.display = "none";
        },

        getQueryString(url) {
            let ItemArr = [];
            let ItemObj = {};
            url
                .substring(url.lastIndexOf("?") + 1, url.length)
                .split("&")
                .map((item) => {
                    ItemArr.push(item.split("="));
                });
            ItemArr.map((item) => {
                ItemObj[item[0]] = item[1];
            });
            return ItemObj;
        },

        jumpXp() {
            let that = this;
            let intervalId = setInterval(function () {
                that.xpValue = that.xpValue + 1;
                if (that.xpValue > 1000) {
                    clearInterval(intervalId);
                }
            }, 1000);
        },

        async getUserLoginInfo() {
            await AccountStore.fetchUserInfo();
            this.isUserLoginStatus = AccountStore.isUserLoginStatus;
            try {
                this.xpNumber = AccountStore.accountBindInfo.xp;
                console.log(AccountStore.accountBindInfo)
            } catch {

            }
            let view = document.getElementById("bee_reward");
            this.loginUrl = AccountStore.accountInfo.loginUrl;
        },




        getReceive() {
            if (!AccountStore.isUserLoginStatus) {
                window.location.href = this.loginUrl;
            } else {
                //

            }

        }



    },

    mounted() {
        this.jumpXp();
        this.getUserLoginInfo();
    },


}

</script>

<style scoped>
.bee_float_layout {
    position: fixed;
    z-index: 2001;
    align-items: center;
    flex-direction: column;
    top: 140px;
    right: -40px;
    display: flex;

}

.reward_content {
    background: #ebb904;
    border-radius: 100%;
    width: 80px;
    height: 80px;
    display: flex;
    justify-content: center;
    align-items: center;
    perspective: 80px;
    flex-direction: column;
    box-shadow: 0px -4px 8px 0px #3333331A;
    /* animation: rotate 10s linear infinite; */
}

@keyframes rotate {
    0% {
        transform: rotateY(0);
    }

    100% {
        transform: rotateY(720deg);
    }
}

.line {
    width: 1px;
    height: 150px;
    background-color: #f2f2f2;
}

.bee_experience_logo {
    width: 18px;
    height: 18px;
    flex-shrink: 0;
    border-radius: 100%;
    margin-left: 2px;
    background-image: url("../assets/icon_task_xp.png");
    background-size: cover;
    background-repeat: no-repeat;
}


.icon_app_close_img {
    width: 16px;
    height: 16px;
    background-image: url("../assets/icon_dialog_close.png");
    background-size: cover;
    background-repeat: no-repeat;
    box-sizing: border-box;
    margin-top: -30px;
    margin-left: 60px;
}

.reward_xp_layout {
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: row;
}

.reward_text {
    font-size: 12px;
    color: #F29100;
    height: 26px;
    border-radius: 30px;
    background: #FFE7B3;
    display: flex;
    text-align: center;
    justify-content: center;
    align-items: center;
    padding-left: 6px;
    padding-right: 6px;
}
</style>